import { WorkerData } from "../data/worker-data";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights = null;

function initAppInsights() {
    if (!WorkerData.appInsightsKey) return;

    appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: WorkerData.appInsightsKey,
            disablePageUnloadEvents: ["unload"],
            disableAjaxTracking: true,
            disableFetchTracking: true,
        },
    });
    appInsights.loadAppInsights();
}

function trackAppEvent(name: string, data) {
    if (!appInsights) return;

    appInsights.trackEvent(
        {
            name: name,
        },
        {
            data: {
                PlayerId: WorkerData.playerId,
                ...data,
            },
        }
    );
}

export function useEventLogger() {
    if (!appInsights && WorkerData.environment != "Development") {
        initAppInsights();
    }
}

export function logNotificationException(message: string, exception: unknown) {
    console.error("notifications-worker", exception);

    const error = exception as Error;
    trackAppEvent("notifications-worker", {
        Type: "error",
        description: message,
        Message: error.message,
        Stack: error.stack,
        ...(exception as Error),
    });
}
